// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__wYu8x","overlay__modal":"Modal_overlay__modal__toDCM"};